export default {
	section_banner: {
		title: {
			one: 'Accept Online &',
		},
		main_title: {
			one: 'Face-To-Face',
		},
		sub_title: {
			one: 'Payments',
		},
		paragraph: {
			one: 'JPWorldPay payment offers a fast, secure, and convenient way to manage your transactions. Whether you are paying online or in person, JPWorldPay allows you to complete payments with just a few taps.',
		},
		cta_buttons: {
			one: 'Contact Now',
			two: 'Download App',
		},
	},

	advantage_sec: {
		label: 'Notification Of Incoming Payment',
		title: {
			one: 'Gain A Competitive',
			two: 'Advantage',
		},
		paragraph:
			'We help small businesses to receive payments almost everywhere. Whether online, in-store, or on the go, JPWorldPay makes it simple and secure to accept payments from customers. With our flexible and reliable platform, small businesses can grow faster, reach more customers, and manage transactions with ease—no matter where they operate.',
	},

	advntage_btm_inn_dwn_1st: {
		label: 'Payment Options',
		title: {
			one: 'Flexibility Required By',
			two: 'Customers',
		},
		paragraph:
			'Have customers pay later, sign up for a subscription, or use global or local payment options.',
		cta_buttons: 'Get Started',
	},
	advntage_btm_inn_dwn_2nd: {
		label: 'Accepted Payments',
		title: {
			one: 'Connect With Global',
			two: 'Buyers',
		},
		paragraph:
			'Payments are accepted online or in stores with all cryptocurrencies. Enjoy seamless checkout experiences.',
		cta_buttons: 'Get Started',
	},
	advntage_btm_inn_dwn_3rd: {
		label: 'Make Payments Quickly',
		title: {
			one: 'Accept Secure Online',
			two: 'Payment',
		},
		paragraph:
			'Make sure your customers pay the way they want and make payments quickly. With JPWorldPay, offer flexibility and speed.',
		cta_buttons: 'Get Started',
	},

	solution_sec: {
		label: 'Online Checkout, Invoicing & More',
		title: {
			one: 'Comprehensive Payment',
			two: 'Solutions',
		},
		paragraph:
			'JPWorldPay offers a complete suite of payment solutions, allowing businesses to accept payments online, in-store, and across social platforms. With features like online checkout, invoicing, estimates, and direct payments, JPWorldPay streamlines the transaction process for both businesses and customers. The  integration of cryptocurrency payment systems also adds flexibility, making it easier than ever to conduct secure, seamless transactions. Whether you are selling online or in person, JPWorldPay simplifies the payment process, helping businesses grow with ease.',
	},

	brcv_solution_dsk_1st: {
		label: 'Online Checkout',
		paragraph:
			'Customers can use a variety of payment methods on a site, mobile or app as a single solution.',
	},
	brcv_solution_dsk_2nd: {
		label: 'Invoice & Estimate',
		paragraph:
			'You can encourage customers to pay by sending free custom invoices that are easy to pay.',
	},
	brcv_solution_dsk_3rd: {
		label: 'Sale on Socials',
		paragraph:
			'Receive payment using our One Tether payment system on various social media platforms.',
	},
	brcv_solution_dsk_4th: {
		label: 'Point Of Sale',
		paragraph:
			'Manage JPWorldPay settings for your business, accept all popular transactions, and track sales.',
	},
	brcv_solution_dsk_5th: {
		label: 'Accept Direct Payment',
		paragraph:
			'Have the customer pay while shopping. Learn how it works. It’s a seamless, self-guided experience.',
	},
	brcv_solution_dsk_6th: {
		label: 'Online Payment System',
		paragraph:
			'Accept online and in-store payments with major cryptocurrencies using our credit and payment services.',
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
